import { cn } from '@finmin/ui';

interface StepIndicatorProps {
  current: number;
  total: number;
  className?: string;
}

/**
 * Horizontal pill progress indicator.
 * Active step = wide filled pill. Past steps = narrow filled. Future = border only.
 */
export function StepIndicator({ current, total, className }: StepIndicatorProps) {
  return (
    <div
      role="progressbar"
      aria-valuenow={current + 1}
      aria-valuemin={1}
      aria-valuemax={total}
      aria-label={`Step ${current + 1} of ${total}`}
      className={cn('flex items-center gap-1.5 mb-6', className)}
    >
      {Array.from({ length: total }, (_, i) => (
        <span
          key={i}
          className={cn(
            'h-1.5 rounded-full transition-all duration-300',
            i === current
              ? 'w-6 bg-accent'
              : i < current
                ? 'w-1.5 bg-accent/40'
                : 'w-1.5 bg-border',
          )}
        />
      ))}
    </div>
  );
}
